import { useEffect, useRef } from 'react';

export default function MouthpieceFlow() {
  const sectionRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll('.fade-up, .fade-left, .fade-right, .draw-line').forEach((el) => {
              el.classList.add('visible');
            });
          }
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    );

    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  const steps = [
    {
      step: 'STEP 01',
      label: '初回',
      title: 'カウンセリングと診査',
      description: '今の悩みや生活背景を丁寧に伺い、レントゲン撮影、CT撮影、スキャン、口腔内写真撮影を行います(所要時間約1時間 無料)',
      image: 'https://storage.readdy-site.link/project_files/8b218f61-770c-4aa3-91e8-64d321e8d024/cb74f35f-f0e3-4fd7-b6df-2cb04b566ee0_unnamed.png?v=ce18e9522a07c321a8ab34a31168d25d',
      dir: 'left' as const,
    },
    {
      step: 'STEP 02',
      label: 'その後',
      title: '専門的な分析',
      description: '診査データをもとに、最適なプラン/費用/期間を整理し、あなた専用 矯正プラン比較レポートを作成します(所要期間約2~3週間)',
      image: 'https://storage.readdy-site.link/project_files/8b218f61-770c-4aa3-91e8-64d321e8d024/80731b62-7fc2-4cce-b1c0-c1d0a0a0e3ff_unnamed.png?v=7c1a50d06a3c8d6728bbeda1ca02ef53',
      dir: 'right' as const,
    },
    {
      step: 'STEP 03',
      label: '後日',
      title: 'あなた専用 矯正プラン比較レポートの説明・お渡し',
      description: '診査データをもとに作成した「あなた専用 矯正プラン比較レポート」を担当スタッフが丁寧に説明します(所要時間約45分 無料)\nご説明は来院・オンラインどちらでも対応可能です。',
      image: 'https://storage.readdy-site.link/project_files/8b218f61-770c-4aa3-91e8-64d321e8d024/292baf97-a340-49ab-bfad-971a2bbeb5bb_unnamed.png?v=f18ee7b62368d39598d9cca04eacd80d',
      note: 'あなた専用 矯正プラン比較レポートは歯科医師の診断内容にもとづいて作成し、担当スタッフが分かりやすく整理してご説明します。',
      dir: 'left' as const,
    },
  ];

  return (
    <section ref={sectionRef} className="py-20 bg-white">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2
          className="text-3xl md:text-4xl font-normal text-center text-gray-900 mb-16 fade-up font-serif"
        >
          来院後の流れ
        </h2>

        <div className="space-y-12">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              <div className={`flex flex-col md:flex-row gap-8 items-start ${step.dir === 'left' ? 'fade-left' : 'fade-right'}`}>
                <div className="flex-1">
                  <div className="flex items-center gap-4 mb-4">
                    <div
                      className="text-white px-4 py-2 rounded-lg font-bold"
                      style={{ backgroundColor: '#3E5F8F' }}
                    >
                      {step.step}
                    </div>
                    <span className="text-gray-600 font-medium">{step.label}</span>
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-4 font-serif">{step.title}</h3>
                  <p className="text-gray-700 leading-relaxed whitespace-pre-line mb-4">
                    {step.description}
                  </p>
                  {step.note && (
                    <div
                      className="border-l-4 p-4 rounded"
                      style={{ borderColor: '#3E5F8F', backgroundColor: '#f8fafc' }}
                    >
                      <p className="text-sm text-gray-700">{step.note}</p>
                    </div>
                  )}
                </div>
                <div className="w-40 mx-auto md:mx-0 md:w-64 flex-shrink-0">
                  <img
                    alt={step.title}
                    className="w-full h-auto rounded-lg shadow-md"
                    src={step.image}
                  />
                </div>
              </div>
              {index < steps.length - 1 && (
                <div className="flex justify-center my-8">
                  <div className="w-0.5 h-12 bg-gray-300 draw-line" />
                </div>
              )}
            </div>
          ))}
        </div>

        <p className="text-center text-gray-700 mt-12 fade-up">
          このプロセスは、有料級の精密診断を行うために必要な時間です。<br />
          ご了承ください。
        </p>
      </div>
    </section>
  );
}